(function () {
  function stripGalleryBadgeOverlays(gallery) {
    gallery.querySelectorAll('.bss_pl_img, .bss_pl_label_text').forEach(function (el) {
      el.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gallery = document.querySelector('.gallery');
    if (!gallery) return;

    stripGalleryBadgeOverlays(gallery);

    var observer = new MutationObserver(function () {
      stripGalleryBadgeOverlays(gallery);
    });
    observer.observe(gallery, { childList: true, subtree: true });

    // The BSS Product Labels app can inject its overlay on a delay after its
    // own script loads, same as it does on the 'Pairs Well With' cards
    // elsewhere in this theme (see sections/main-product.liquid) — belt and
    // suspenders in case the MutationObserver misses a very early insert.
    setTimeout(function () { stripGalleryBadgeOverlays(gallery); }, 500);
    setTimeout(function () { stripGalleryBadgeOverlays(gallery); }, 2000);
  });
})();
